module.exports = __webpack_public_path__ + "img/file.f34b8b7c.svg";